const TOKEN_KEY = 'auth_token';
const USER_KEY = 'auth_user';

export function getToken(): string | null {
  try {
    const val = uni.getStorageSync(TOKEN_KEY);
    return val || null;
  } catch {
    return null;
  }
}

export function setToken(token: string) {
  uni.setStorageSync(TOKEN_KEY, token);
}

export function removeToken() {
  try {
    uni.removeStorageSync(TOKEN_KEY);
  } catch { /* ignore */ }
}

export function removeUser() {
  try {
    uni.removeStorageSync(USER_KEY);
  } catch { /* ignore */ }
}

export function isLoggedIn(): boolean {
  return !!getToken();
}

export function getUser(): Record<string, any> | null {
  try {
    const raw = uni.getStorageSync(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setUser(user: Record<string, any>) {
  uni.setStorageSync(USER_KEY, JSON.stringify(user));
}

export function logout() {
  removeToken();
  removeUser();
}
